//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

if (typeof window !== 'undefined' && typeof component !== 'undefined' && window.Vue) {
      window.Vue.component('PuiNextPrev', component.exports)
    } export default {
  props: {
    prev: Boolean,
    next: Boolean,
    icon: String, // eslint-disable-line
    to: String, // eslint-disable-line
    top: Boolean,
    right: Boolean,
    bottom: Boolean,
    left: Boolean,
    outside: Boolean
  },
  computed: {
    dynamicComp() {
      return this.to ? 'router-link' : 'div'
    },
    position() {
      const space = 'var(--space);'

      return `
        ${this.top ? `top: ${space}` : ''}
        ${this.right ? `right: ${space}` : ''}
        ${this.bottom ? `bottom: ${space}` : ''}
        ${this.left ? `left: ${space}` : ''}
      `.replace(/\s+/g, '')
    }
  }
}
